import React from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import useReveal, { revealClass } from '../hooks/useReveal'
import RevealImage from './revealImage'

const Seccion_Video= ({id, title, phg1, phg2, video, images}) => {
  const [ref, visible] = useReveal()

  return (
    <div ref={ref} id={id} className={`flex flex-col h-full w-full gap-12 py-10 ${revealClass(visible)}`}>
        <h3>{title}</h3>
       
          
          <ResponsiveMasonry 
                columnsCountBreakPoints={{350: 1, 750: 1, 1024:2, 1280: 2}}
            >
                <Masonry gutter="20px">
                <p>{phg1}</p> 
                {images.map((image, index) => (
                  <RevealImage
                    key={index}
                    index={index}
                    src={image}
                    alt={"Maria_Estevez_"+title+"_"+index}
                  />
                ))}
                 
                <div className='relative w-full h-full'>
                <iframe className='w-full h-full aspect-video' width="560" height="315" src={video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                <p>{phg2}</p>

                </Masonry>
            </ResponsiveMasonry>
        
    </div>
  )
}

export default Seccion_Video